if (dataLayerDebugMode) {
    console.log('dataLayer-collection - Debug mode: on');
}

/** DATALAYER: View item list */
document.addEventListener('DOMContentLoaded', function() {
    var waitForListingProductsTries = 0;

    function onListingProductsLoaded() {
        let productItems = document.querySelectorAll('#product-grid .card-wrapper');

        if (productItems.length <= 0) {
            waitForListingProductsTries++;

            if (waitForListingProductsTries < 10) {
                setTimeout(onListingProductsLoaded, 1000);
            }
        } else {
            let ecommerce_data = {};

            productItems.forEach(function(productItem, index) {
                let productData = JSON.parse(productItem.getAttribute('data-product-info'));
                if (index == 0) {
                    ecommerce_data['item_list_name'] = productData.gtmItemListName;
                    ecommerce_data['item_list_id'] = productData.gtmItemListId;
                    ecommerce_data['items'] = [];
                }

                ecommerce_data['items'][index] = {
                    'item_id': productData.gtmItemId,
                    'item_name': productData.gtmItemName,
                    'item_brand': productData.gtmItemBrand,
                    'item_category': productData.gtmItemCategory,
                    'item_category2': productData.gtmItemCategory2,
                    'item_category3': productData.gtmItemCategory3,
                    'price': productData.gtmItemPrice,
                    'discount': '',
                    'coupon': '',
                    'currency': productData.gtmItemCurrency,
                    'index': productData.gtmItemIndex,
                    'item_sale_value': productData.gtmItemSaleValue,
                    'item_sale': productData.gtmItemSale,
                    'item_availability': productData.gtmItemAvailability,
                    'affiliation': productData.gtmItemAffiliation,
                    'item_variant': productData.gtmItemVariant,
                    'item_sku': productData.gtmItemSku,
                    'quantity': productData.gtmItemQuantity
                }
            });

            dataLayer.push({
                'event': 'view_item_list',
                'ecommerce': ecommerce_data
            });

            if(Antonioli.customerId != ''){
                dataLayer.push({
                  'user_id': Antonioli.customerId
                })
            };

            if (dataLayerDebugMode) {
                console.log('dataLayer debug - view_item_list: ', ecommerce_data);
            }
        }
    }

    onListingProductsLoaded();
});

/** DATALAYER: Select Item */
let dataLayer_collection_callbackClick = false;

document.addEventListener('click', function(event) {

    if (event.target.closest('.card-wrapper')) {
        
        if (dataLayer_collection_callbackClick) {
            return;
        }

        let eventTargetProductItem = event.target.closest('.card-wrapper');

        if (
            eventTargetProductItem &&
            eventTargetProductItem.getAttribute('data-product-info')
        ) {
            let productData = JSON.parse(eventTargetProductItem.getAttribute('data-product-info'));

            if (productData) {
                event.preventDefault();

                let ecommerce_data = {};
                ecommerce_data['currency'] = productData.gtmItemCurrency;
                ecommerce_data['value'] = productData.gtmItemPrice;
                ecommerce_data['item_list_name'] = productData.gtmItemListName;
                ecommerce_data['item_list_id'] = productData.gtmItemListId;
                ecommerce_data['items'] = [{
                    'item_id': productData.gtmItemId,
                    'item_name': productData.gtmItemName,
                    'item_brand': productData.gtmItemBrand,
                    'item_category': productData.gtmItemCategory,
                    'item_category2': productData.gtmItemCategory2,
                    'item_category3': productData.gtmItemCategory3,
                    'price': productData.gtmItemPrice,
                    'discount': '',
                    'coupon': '',
                    'currency': productData.gtmItemCurrency,
                    'index': productData.gtmItemIndex,
                    'item_sale_value': productData.gtmItemSaleValue,
                    'item_sale': productData.gtmItemSale,
                    'item_availability': productData.gtmItemAvailability,
                    'affiliation': productData.gtmItemAffiliation,
                    'item_variant': productData.gtmItemVariant,
                    'item_sku': productData.gtmItemSku,
                    'quantity': productData.gtmItemQuantity
                }];

                dataLayer.push({
                    'event': 'select_item',
                    'ecommerce': ecommerce_data,
                    'eventCallback': function() {
                        dataLayer_collection_callbackClick = true;
                        event.target.click();
                    },
                    'eventTimeout': 2000
                });

                if(Antonioli.customerId != ''){
                    dataLayer.push({
                      'user_id': Antonioli.customerId
                    })
                };

                if (dataLayerDebugMode) {
                    console.log('dataLayer debug - select_item: ' , ecommerce_data);
                }
            }
        }
    }
});
